import { PureComponent } from 'react';

import PermissionRoute from 'components/Shared/PermissionRoute';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import AdminPage from './Admin';
import NewPasswordPage from './Public/NewPassword';

export default class Pages extends PureComponent {
  renderRedirect = () => <Redirect to='/' />;
  renderEmpty = () => <div />;

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path='/nova-senha' exact component={NewPasswordPage} />
          <PermissionRoute role={null} path='/' component={AdminPage} />

          <Route path='/reload' exact render={this.renderEmpty} />
          <Route render={this.renderRedirect} />
        </Switch>
      </BrowserRouter>
    );
  }
}
